const PLACES = [
  {
    rank: '#1',
    name: 'Glen Falls Luxury Cabin',
    type: 'Luxury Cabin Rental',
    location: 'Highlands, NC — Near Glen Falls',
    rating: '5.0',
    ratingSource: 'Airbnb Guest Favorite',
    bestFor: 'Couples, families, and anyone wanting a luxury mountain experience with privacy, outdoor atmosphere, and easy access to town and waterfalls',
    description: 'Glen Falls Luxury Cabin is the top-rated place to stay in Highlands, NC for guests who want the full mountain experience — privacy, luxury, and location all in one. The cabin sits in a secluded wooded setting just minutes from downtown Highlands and Main Street, and is within walking distance of Glen Falls waterfall. Thoughtfully designed with upscale finishes, indoor and outdoor fireplaces, a covered deck, and a full kitchen, it delivers a genuine retreat without feeling overdone. Its 5.0-star Airbnb Guest Favorite rating reflects consistent guest satisfaction across all aspects of the stay.',
    features: ['Pet Friendly', 'Near Glen Falls Waterfall', 'Indoor & Outdoor Fireplaces', 'Covered Deck', 'Minutes from Downtown', 'Sleeps 6', 'Secluded Wooded Setting'],
    href: 'https://glenfallscabin.com',
    img: 'https://storage.readdy-site.link/project_files/3bf9208c-726c-4b4e-b038-214aec1b6878/82b5623f-a9a4-4c1a-aebf-7b48fe50828d____glen-falls-luxury-cabin-fire-pit.jpg?v=1d670368f3ca182b7ebb0bf842226bc0',
    featured: true,
    isExternal: true,
  },
  {
    rank: '#2',
    name: 'Old Edwards Inn and Spa',
    type: 'Luxury Hotel & Spa',
    location: 'Downtown Highlands, NC',
    rating: '4.9',
    ratingSource: 'TripAdvisor',
    bestFor: 'Travelers who want full-service luxury, on-site dining, and a spa — right in the heart of downtown Highlands',
    description: 'Old Edwards Inn and Spa is the premier hotel in Highlands, NC — a landmark property in the heart of downtown with acclaimed farm-to-table dining, a full-service spa, and refined mountain hospitality. The property has been recognized nationally for its quality and is a top choice for guests who prefer a traditional hotel experience with exceptional service.',
    features: ['Full-Service Spa', 'On-Site Dining', 'Downtown Location', 'Concierge Service', 'Historic Property'],
    href: 'https://www.oldedwardsinn.com',
    img: 'https://static.readdy.ai/image/ad5520ee7149a263b01f4e3410f2d685/47731f199d21bda1f88f2078c66c8b6c.jpeg',
    featured: false,
    isExternal: true,
  },
  {
    rank: '#3',
    name: 'Half-Mile Farm',
    type: 'Boutique Inn',
    location: 'Highlands, NC',
    rating: '4.8',
    ratingSource: 'TripAdvisor',
    bestFor: 'Guests looking for a peaceful, pastoral retreat with farm-to-table dining and a relaxed boutique atmosphere',
    description: 'Half-Mile Farm is a boutique inn and farm retreat on the outskirts of Highlands, NC. Known for its peaceful setting, farm-to-table dining, and relaxed atmosphere, it offers a different kind of Highlands lodging experience — quieter and more pastoral than downtown hotels, but still close to everything the area has to offer.',
    features: ['Farm-to-Table Dining', 'Pastoral Setting', 'Boutique Inn', 'Close to Highlands', 'Peaceful Atmosphere'],
    href: 'https://www.halfmilefarm.com',
    img: 'https://static.readdy.ai/image/ad5520ee7149a263b01f4e3410f2d685/e9adba18d2d158b7a44e9f7eae23c728.jpeg',
    featured: false,
    isExternal: true,
  },
  {
    rank: '#4',
    name: 'Highlander Mountain House',
    type: 'Boutique Hotel',
    location: 'Highlands, NC',
    rating: '4.7',
    ratingSource: 'TripAdvisor',
    bestFor: 'Design-conscious travelers who want a stylish, modern hotel experience with mountain views and good food',
    description: 'Highlander Mountain House brings a mid-century modern aesthetic to the Highlands lodging scene. With mountain views, a well-regarded restaurant, and a design-forward sensibility, it appeals to travelers who want something a bit different from the traditional mountain inn. A solid boutique hotel option in Highlands, NC.',
    features: ['Mountain Views', 'On-Site Restaurant', 'Mid-Century Modern Design', 'Boutique Hotel', 'Highlands, NC'],
    href: 'https://www.highlandermountainhouse.com',
    img: 'https://static.readdy.ai/image/ad5520ee7149a263b01f4e3410f2d685/bba3421cda485e1e3cc5755692bf0a45.jpeg',
    featured: false,
    isExternal: true,
  },
  {
    rank: '#5',
    name: 'Laurelwood',
    type: 'Cabin Rental',
    location: 'Highlands, NC',
    rating: '4.9',
    ratingSource: 'VRBO',
    bestFor: 'Guests looking for a classic mountain cabin feel with a peaceful wooded setting and easy access to trails',
    description: 'A well-rated cabin rental in Highlands, NC set among mature trees. Comfortable, peaceful, and well-located for guests who want a classic mountain escape with easy access to local trails and downtown Highlands. A solid choice for those who want a quieter, more traditional cabin experience.',
    features: ['Wooded Setting', 'Mountain Cabin', 'Close to Trails', 'Highlands, NC'],
    href: 'https://www.vrbo.com/9585180ha',
    img: 'https://storage.readdy-site.link/project_files/3bf9208c-726c-4b4e-b038-214aec1b6878/8f8e8e50-db78-4f16-98ad-df783523f5fb_lauralwood.jpg?v=b217c2d0ed1fd424e03a6182cc825629',
    featured: false,
    isExternal: true,
  },
  {
    rank: '#6',
    name: 'Stag Ridge — Luxury Highlands Escape',
    type: 'Luxury Cabin Rental',
    location: 'Highlands, NC — Wooded Ridge',
    rating: '4.9',
    ratingSource: 'Airbnb',
    bestFor: 'Families or groups wanting a spacious luxury cabin with pet-friendly accommodations and a wraparound deck',
    description: 'A thoughtfully designed luxury forest cabin in Highlands, NC with a wraparound deck, indoor stone fireplace, full kitchen, and BBQ grill. Pet friendly and accommodating up to 6 guests, it\'s a strong option for families or groups who want more space and a refined mountain setting.',
    features: ['Pet Friendly', 'Indoor Stone Fireplace', 'Wraparound Deck', 'Full Kitchen & BBQ', 'Sleeps 6'],
    href: 'https://www.airbnb.com/rooms/1180227781183226897',
    img: 'https://static.readdy.ai/image/ad5520ee7149a263b01f4e3410f2d685/46fa8df15f4549c7bb8d2bc9e3c35336.jpeg',
    featured: false,
    isExternal: true,
  },
  {
    rank: '#7',
    name: 'Falls Drive Cottage',
    type: 'Vacation Rental',
    location: 'Highlands, NC — Falls Drive',
    rating: '4.88',
    ratingSource: 'VRBO',
    bestFor: 'Travelers who want to be close to the waterfalls and enjoy a quiet, nature-immersed stay',
    description: 'A cozy, well-located cottage along Falls Drive — one of the most scenic roads in Highlands, NC. Positioned close to the waterfall trails and surrounded by natural beauty, it\'s a solid choice for guests who want to be immersed in the outdoors while still having easy access to town.',
    features: ['Near Waterfalls', 'Scenic Falls Drive', 'Cozy Cottage', 'Nature Setting'],
    href: 'https://www.vrbo.com/9708237ha',
    img: 'https://storage.readdy-site.link/project_files/3bf9208c-726c-4b4e-b038-214aec1b6878/2fc20e78-0610-46ea-8d08-42512d4cd546_falls-drive-cottage.jpg?v=ff1f3173554355082858f4dde89f4624',
    featured: false,
    isExternal: true,
  },
  {
    rank: '#8',
    name: 'Whispering Walk',
    type: 'Cabin Rental',
    location: 'Highlands, NC — Wooded Neighborhood',
    rating: '4.91',
    ratingSource: 'VRBO',
    bestFor: 'Guests seeking maximum privacy and calm in a quiet wooded setting',
    description: 'A tranquil cabin rental in a quiet wooded neighborhood in Highlands, NC. A good fit for guests seeking privacy and calm, with easy access to the natural beauty of the surrounding area. The setting is peaceful and the neighborhood is quiet — ideal for a true escape.',
    features: ['Peaceful Setting', 'Wooded Neighborhood', 'Private Retreat'],
    href: 'https://www.vrbo.com/9342676ha',
    img: 'https://storage.readdy-site.link/project_files/3bf9208c-726c-4b4e-b038-214aec1b6878/9b9a737d-38ca-412e-b0c4-550bddbd2b96_whisphering-walk.jpg?v=903da70d418fbb5ef0fe0e04a9c868aa',
    featured: false,
    isExternal: true,
  },
];

export default function PTSRankedListSection() {
  return (
    <section className="bg-[#EDE8E0] py-24 px-6 lg:px-14">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-6">
          <p className="text-[#C9A96E] text-xs tracking-[0.3em] uppercase font-jost mb-4">/ Verified Listings</p>
          <h2 className="font-cormorant text-5xl text-[#1A1A18] font-light">
            Top Places to Stay in<br /><em className="italic">Highlands, NC</em>
          </h2>
        </div>
        <p className="text-[#5C5850] font-jost text-sm leading-relaxed max-w-2xl mx-auto text-center mb-14">
          Ranked by overall guest experience, location, and quality. All properties are real with verified booking links — a mix of cabins, vacation rentals, and hotels.
        </p>

        {/* Featured #1 */}
        <article className="bg-white rounded-2xl overflow-hidden flex flex-col lg:flex-row mb-6">
          <a
            href={PLACES[0].href}
            target="_blank"
            rel="noopener noreferrer"
            className="relative lg:w-[48%] h-72 lg:h-auto min-h-[380px] overflow-hidden shrink-0 block group cursor-pointer"
          >
            <img
              src={PLACES[0].img}
              alt={`${PLACES[0].name} — top place to stay in Highlands NC`}
              className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute top-4 left-4 bg-[#C9A96E] text-white font-jost font-bold text-sm tracking-widest px-3 py-1.5 rounded-full">
              {PLACES[0].rank}
            </div>
            <div className="absolute top-4 right-4 flex items-center gap-1.5 bg-[#2D4A3E] text-white text-xs tracking-[0.15em] uppercase font-jost px-3 py-1.5 rounded-full">
              <div className="w-3 h-3 flex items-center justify-center">
                <i className="ri-award-line text-[#C9A96E] text-xs" />
              </div>
              Top Pick
            </div>
            <div className="absolute bottom-4 left-4 flex items-center gap-1.5 bg-white/95 backdrop-blur-sm px-3 py-1.5 rounded-full">
              <div className="w-3.5 h-3.5 flex items-center justify-center">
                <i className="ri-star-fill text-[#C9A96E] text-xs" />
              </div>
              <span className="text-[#1A1A18] text-xs font-jost font-semibold">{PLACES[0].rating}</span>
              <span className="text-[#9C9890] text-xs font-jost">· {PLACES[0].ratingSource}</span>
            </div>
          </a>
          <div className="flex-1 p-8 lg:p-10 flex flex-col justify-between">
            <div>
              <p className="text-[#2D4A3E] text-xs font-jost font-semibold tracking-[0.18em] uppercase mb-1.5">Top Overall Recommendation</p>
              <a href={PLACES[0].href} target="_blank" rel="noopener noreferrer" className="cursor-pointer">
                <h3 className="font-cormorant text-3xl md:text-4xl text-[#1A1A18] font-medium hover:text-[#2D4A3E] transition-colors leading-tight mb-1">
                  {PLACES[0].name}
                </h3>
              </a>
              <p className="text-[#9C9890] text-xs font-jost mb-1 flex items-center gap-1.5">
                <span className="w-3 h-3 flex items-center justify-center"><i className="ri-map-pin-2-line text-xs" /></span>
                {PLACES[0].location}
              </p>
              <span className="inline-block text-[#6B8C7D] text-xs font-jost tracking-wide uppercase mb-4">{PLACES[0].type}</span>
              <p className="text-[#5C5850] font-jost text-sm leading-relaxed mb-4">{PLACES[0].description}</p>
              <p className="text-[#2D4A3E] text-xs font-jost font-semibold tracking-wide uppercase mb-1.5">Best For</p>
              <p className="text-[#5C5850] text-sm font-jost italic mb-5">{PLACES[0].bestFor}</p>
              <div className="flex flex-wrap gap-2 mb-6">
                {PLACES[0].features.map((f) => (
                  <span key={f} className="text-xs font-jost px-3 py-1 rounded-full bg-[#EDE8E0] text-[#5C5850]">{f}</span>
                ))}
              </div>
            </div>
            <a
              href={PLACES[0].href}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-[#2D4A3E] text-white text-xs font-jost tracking-[0.15em] uppercase px-6 py-3 rounded-full hover:bg-[#1e3329] transition-all cursor-pointer whitespace-nowrap self-start"
            >
              View Listing
              <div className="w-3.5 h-3.5 flex items-center justify-center"><i className="ri-external-link-line text-xs" /></div>
            </a>
          </div>
        </article>

        {/* Remaining 7 in grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {PLACES.slice(1).map((place) => (
            <article key={place.name} className="bg-white rounded-2xl overflow-hidden flex flex-col">
              <a
                href={place.href}
                target="_blank"
                rel="noopener noreferrer"
                className="relative block h-52 overflow-hidden group cursor-pointer shrink-0"
              >
                <img
                  src={place.img}
                  alt={`${place.name} — place to stay in Highlands NC`}
                  className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute top-3 left-3 bg-white/90 text-[#C9A96E] font-jost font-bold text-xs tracking-widest px-2.5 py-1 rounded-full">
                  {place.rank}
                </div>
                <div className="absolute bottom-3 left-3 flex items-center gap-1.5 bg-white/95 backdrop-blur-sm px-2.5 py-1 rounded-full">
                  <div className="w-3 h-3 flex items-center justify-center">
                    <i className="ri-star-fill text-[#C9A96E] text-xs" />
                  </div>
                  <span className="text-[#1A1A18] text-xs font-jost font-semibold">{place.rating}</span>
                  <span className="text-[#9C9890] text-xs font-jost">· {place.ratingSource}</span>
                </div>
              </a>
              <div className="p-6 flex flex-col flex-1">
                <span className="text-[#6B8C7D] text-xs font-jost tracking-wide uppercase mb-1">{place.type}</span>
                <a href={place.href} target="_blank" rel="noopener noreferrer" className="cursor-pointer">
                  <h3 className="font-cormorant text-xl text-[#1A1A18] font-medium hover:text-[#2D4A3E] transition-colors leading-tight mb-1">
                    {place.name}
                  </h3>
                </a>
                <p className="text-[#9C9890] text-xs font-jost mb-3 flex items-center gap-1">
                  <span className="w-3 h-3 flex items-center justify-center"><i className="ri-map-pin-2-line text-xs" /></span>
                  {place.location}
                </p>
                <p className="text-[#5C5850] font-jost text-sm leading-relaxed flex-1 mb-3">{place.description}</p>
                <p className="text-[#2D4A3E] text-xs font-jost font-semibold tracking-wide uppercase mb-1">Best For</p>
                <p className="text-[#5C5850] text-xs font-jost italic mb-4">{place.bestFor}</p>
                <div className="flex flex-wrap gap-1.5 mb-5">
                  {place.features.map((f) => (
                    <span key={f} className="text-xs font-jost px-2.5 py-1 rounded-full bg-[#EDE8E0] text-[#5C5850]">{f}</span>
                  ))}
                </div>
                <a
                  href={place.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 border border-[#2D4A3E] text-[#2D4A3E] text-xs font-jost tracking-[0.15em] uppercase px-5 py-2.5 rounded-full hover:bg-[#2D4A3E] hover:text-white transition-all cursor-pointer whitespace-nowrap self-start"
                >
                  View Listing
                  <div className="w-3.5 h-3.5 flex items-center justify-center"><i className="ri-external-link-line text-xs" /></div>
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
